export const contactSectionTitle = 'Get in touch';
export const contactSectionSubtitle = 'Contact me';
export const data = [
    {
        iconClassName: 'bx bxl-linkedin contact__card-icon',
        title: 'LinkedIn',
        link: 'https://linkedin.com/in/stelmaszczykadrian',
        buttonText: 'LinkedIn profile',
    },
    {
        iconClassName: 'bx bxl-github contact__card-icon',
        title: 'GitHub',
        link: 'https://github.com/stelmaszczykadrian',
        buttonText: 'GitHub profile',
    },
    {
        iconClassName: 'bx bx-mail-send contact__card-icon',
        title: 'Email',
        link: 'mailto:stelmaszczykadrian@gmail.com',
        buttonText: 'Write me',
    },
];
